import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

//const API_ROOT = 'http://localhost/api'

export const getProposalRevise = (projectVersionId) => {
  const url = `${API_ROOT}/review/${projectVersionId}/proposal-revise`
  console.log('url', url)
  return doGet(url)
}

export const saveProposalRevise = (projectVersionId, request) => {
  const url = `${API_ROOT}/review/${projectVersionId}/proposal-revise`
  console.log('url', url)
  return doPost(url, request)
}

export const getProposalReviseNew = (projectVersionId) => {
  const url = `${API_ROOT}/review/${projectVersionId}/proposal-revise-request`
  console.log('url', url)
  return doGet(url)
}

export const saveProposalReviseNew = (projectVersionId, request) => {
  const url = `${API_ROOT}/review/${projectVersionId}/proposal-revise-request`
  console.log('url', url)
  return doPost(url, request)
}
